var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "grid-container top-bar-grid" }, [
      _c(
        "label",
        [
          _vm.hasGoalDefined
            ? [
                _vm._v(
                  "\n                Gewenste doelgroep grootte:\n            "
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "goal" },
        [
          _vm.hasGoalDefined
            ? [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm._f("readableNumber")(_vm.audienceProgress.goal)
                    ) +
                    "\n            "
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("label", { staticClass: "text-right" }, [
        _vm._v(
          "\n            Laatste gegevens omgehaald om " +
            _vm._s(_vm.lastRetrievedDisplay) +
            "\n        "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-container progress-bar-grid" }, [
      _c("div", { staticClass: "progress" }, [
        _c(
          "div",
          {
            staticClass: "progress-bar",
            class: {
              "progress-bar-animated progress-bar-striped": _vm.isLoading
            },
            attrs: {
              role: "progressbar",
              "data-percentage": _vm.percentageTowardsGoal,
              "aria-valuenow": _vm.audienceProgress.total,
              "aria-valuemin": "0",
              "aria-valuemax": _vm.audienceProgress.goal
            }
          },
          [
            _vm.hasTotalDefined
              ? _c("div", { staticClass: "text-right pr-3" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("readableNumber")(_vm.audienceProgress.total)
                      )
                    )
                  ])
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "mdb-icon-btn", on: { click: _vm.loadProgress } },
        [
          _c("i", {
            staticClass: "fas fa-2x fa-sync",
            class: { "fa-spin": _vm.isLoading }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }